import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { VendorsPage } from './pages/VendorsPage';
import { StoreDetailsPage } from './pages/StoreDetailsPage';
import { SuppliesPage } from './pages/SuppliesPage';
import { CalculatorPage } from './pages/CalculatorPage';
import { ExclusiveDealsPage } from './pages/ExclusiveDealsPage';
import { ConfirmEmailPage } from './pages/ConfirmEmailPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ResearchToolsPage } from './pages/ResearchToolsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { vendorService } from './services/vendorService';
import { remoteConfigService } from './services/remoteConfigService';
import './styles/global.css';
import './App.css';

/**
 * Main App component with routing
 */
function App() {
  useEffect(() => {
    // Initialize services
    vendorService.initialize().catch((error) => {
      console.error('Failed to initialize vendors:', error);
    });

    remoteConfigService.initialize().catch((error) => {
      console.error('Failed to initialize remote config:', error);
    });

    // Set up periodic refresh
    const cleanup = remoteConfigService.startPeriodicRefresh();
    return cleanup;
  }, []);

  return (
    <ThemeProvider initialMode="light">
      <BrowserRouter>
        <div className="app">
          <a href="#main-content" className="skip-link">
            Skip to main content
          </a>
          <Navigation />
          <main id="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/research-tools" element={<ResearchToolsPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/vendors/:vendorId/details" element={<StoreDetailsPage />} />
              <Route path="/supplies" element={<SuppliesPage />} />
              <Route path="/calculator" element={<CalculatorPage />} />
              <Route path="/exclusive-deals" element={<ExclusiveDealsPage />} />
              <Route path="/confirm-email" element={<ConfirmEmailPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

